export { default as WorkloadsTable } from "./WorkloadsTable";
